<template>
  <!-- 搜索组件 -->
  <div class="search_wrap">
    <a-row type="flex" justify="space-between">
      <a-col :span="14">
        <a-row>
          <a-col :span="10" v-if="showView">
            <slot name="view"></slot>
          </a-col>
          <a-col :span="14">
            <!-- 普通搜索 -->
            <a-input-search :placeholder="`${$t('formAbout.search')}`" v-model="searchContent" @search="onSearch" @change.native="onBlur" />
          </a-col>
        </a-row>
      </a-col>
      <!-- 有高级搜索 -->
      <a-col v-if="hasISenior">
        <span class="btn_text" @click="extendSenior"> {{ iSeniorShow ? `${$t('formAbout.ordinarySearch')}` : `${$t('formAbout.advancedSearch')}` }} </span>
        <span class="btn-style">
          <slot name="btn"></slot>
        </span>
      </a-col>
      <!-- 没有高级搜索，但有其他操作按钮 -->
      <a-col class="operation-box" v-else>
        <slot name="operation"></slot>
      </a-col>
    </a-row>
    <a-row v-if="iSeniorShow">
      <slot name="senior"></slot>
    </a-row>
  </div>
</template>

<script>
export default {
  name: 'Search',
  props: {
    // 是否显示视图
    showView: {
      type: Boolean,
      default: false
    },
    hasISenior: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      searchContent: '',
      // 高级搜索是否显示 false: 不显示 true：显示
      iSeniorShow: false
    }
  },
  methods: {
    /**
     * 输入值
     */
    onBlur () {
      this.$emit('on-blur', this.searchContent)
    },
    /**
     * 搜索
     */
    onSearch () {
      this.onBlur()
      this.$emit('on-search', this.searchContent)
    },
    /**
     * 切换高级搜索的显示
     */
    extendSenior () {
      // 清空普通搜索的值
      this.iSeniorShow = !this.iSeniorShow
    }
  }
}
</script>

<style lang="less" scoped>
.btn_text {
  color: #4977FC;
  cursor: pointer;
}
.btn-style {
  padding-left: 20px;
  /deep/i,
  /deep/button {
    margin-left: 5px;
    &:first-of-type {
      margin-left: 0;
    }
  }
  /deep/i {
    cursor: pointer;
    &:hover {
      color: #4977FC;
    }
  }
}
.operation-box {
  /deep/button {
    margin-left: 5px;
  }
}
</style>
